import { render, staticRenderFns } from "./AppFourthScreen.vue?vue&type=template&id=038eac17&scoped=true"
import script from "./AppFourthScreen.vue?vue&type=script&lang=js"
export * from "./AppFourthScreen.vue?vue&type=script&lang=js"
import style0 from "./AppFourthScreen.vue?vue&type=style&index=0&id=038eac17&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038eac17",
  null
  
)

export default component.exports